module.exports = __webpack_public_path__ + "img/02-ABC.b11cad3c.png";